import CustomersController from './customers.controller.js';
import CustomerUpdateController from './customer-update.controller.js';
import CustomerPointsChangeStatusController from './points/change-status.controller.js';
import CustomerAddPointsController from './points/add-points.controller.js';

// Import html templates
import './partials/reservations.html';
import './partials/points.html';
import './partials/redemptionErrors.html';

import customersTpl from './customers.html';
import customersEditTpl from './customer.update.html';
import changeStatusTpl from './points/changeStatus.html';
import addPointsTpl from './points/add.html';

export default function customersRouter($stateProvider) {
  $stateProvider
    .state('app.customers', {
      url: '/customers',
      templateUrl: customersTpl,
      controller: CustomersController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['CUSTOMER_READ'],
      },
    })
    .state('app.customers.edit', {
      url: '/:customerId/edit',
      templateUrl: customersEditTpl,
      params: {
        customerId: null,
        tab: null,
      },
      controller: CustomerUpdateController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['CUSTOMER_UPDATE'],
      },
    })
    .state('app.customers.changeStatus', {
      url: '/:customerId/changeStatus',
      templateUrl: changeStatusTpl,
      params: {
        customerId: null,
        customer: null,
        point: null,
      },
      controller: CustomerPointsChangeStatusController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['CUSTOMER_POINTS_UPDATE'],
      },
    })
    .state('app.customers.addPoints', {
      url: '/:customerId/addPoints',
      templateUrl: addPointsTpl,
      params: {
        customerId: null,
        customer: null,
      },
      controller: CustomerAddPointsController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['CUSTOMER_POINTS_UPDATE'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/customers/customers.router.js